// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"9250b374","400":"78c49db2","453":"68d2f560","507":"693a7840","889":"b9965cf0","949":"3d2bbc0f"}[chunkId] + ".chunk.js";
};